import { render, staticRenderFns } from "./47.vue?vue&type=template&id=2027ff80&"
import script from "./47.vue?vue&type=script&lang=js&"
export * from "./47.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports